<template>
  <div id="Index">
    <div class="mui-content">
      <center>
        <div class="logoDiv">
          <div>
            <img id="logo" src="../assets/logo.png" width="50%" />
          </div>
          <div class="titleDiv">{{ title }}</div>
          <div class="msgDiv">{{ msg }}</div>
          <div class="copyrightDiv">{{ copyright }} </br> {{copyright1}}</div>
        </div>
        <div class="startBtn" @click="startBtn">
          <van-button
            round
            class="w-75"
            type="info"
            color="linear-gradient(to right, #4bb0ff, #6149f6)"
            style="box-shadow: 1px 2px 3px #979797"
          >
            <span style="letter-spacing: 3px">立即体验</span>
          </van-button>
        </div>
        <div class="floatDiv" v-if="totalTime > 0">
          <van-tag plain round type="primary" @click="startBtn">
            跳过
            <b>{{ totalTime }}</b>
          </van-tag>
        </div>
      </center>
    </div>
  </div>
</template>

<script>
export default {
  name: "Index",
  data () {
    return {
      title: "山东省人事考试中心",
      msg: "考务移动端管理系统",
      copyright: "Copyright © 2025山东省人事考试中心 ",
      copyright1: "鲁ICP备2021017574号-3X",
      totalTime: 3 //计时器
    };
  },
  methods: {
    //跳过按钮事件
    startBtn: function () {
      // 如果当前用户已登录,跳转到默认页面
      if (this.getAuth()) {
        var work = this.getWork() || "";
        if (work) this.$router.push(this.$backurl(work.User.RoleTypeID));
        else this.$router.push({ name: "ExamManage" });
      } else {
        this.$router.push({ name: "Login" }); //没有用户登录信息的话跳到登录页
      }
    },
    //延时事件
    countdownTimer: function () {
      setTimeout(() => {
        if (this.totalTime > 0) {
          this.totalTime--;
          this.countdownTimer();
        } else {
          this.startBtn();
        }
      }, 1000);
    }
  },
  created () { },
  mounted () {
    //初始化页面完成后执行
    var thisVer = this.Ver(); //获取当前版本
    //判断当前环境是否支持plus方法
    this.getVersion(this, res => {
      //console.log("系统运行检测项", res);
      //console.log("进行版本检测","当前版本:", this.Ver(), "服务器版本:", res.data.Version);
      if (res.code == 20000) {
        this.setVer(res.data);
        if (thisVer == res.data.Version) {
          this.countdownTimer();
        } else {
          if (window.plus) {
            // eslint-disable-next-line no-undef
            if (plus) {
              this.$dialog
                .confirm({
                  title: "提示",
                  message: "新版已发布,请尽快升级"
                })
                .then(() => {
                  // on confirm
                  this.$router.push({ name: "Update" }); //跳转到更新页面
                })
                .catch(() => {
                  // on cancel
                  this.countdownTimer();
                });
            }
          } else {
            // eslint-disable-next-line no-console
            console.log("调试模式下跳过更新检测");
            this.countdownTimer();
          }
        }
      } else {
        this.$toast(res.message);
      }
    });
  }
};
</script>

<style scoped>
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.floatDiv {
  position: absolute;
  top: 2%;
  right: 3%;
}
.logoDiv {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: 20% 0 50% 0;
  background: #ffffff;
}
#logo {
  margin: 5% auto 0 auto;
}
.titleDiv {
  margin: 3rem 0 0 0;
  font-size: 1.5rem;
  font-family: Arial, Helvetica, sans-serif;
}
.msgDiv {
  margin: 1.5rem auto 1.5rem auto;
  font-size: 0.92rem;
  color: #333;
  letter-spacing: 7px;
}
.startBtn {
  position: absolute;
  top: 65%;
  width: 90%;
  text-align: center;
  font-size: 0.75rem;
  margin: 0 5% 0 5%;
  padding: 1rem 0 1rem 0;
  /* border-top: 1px dashed #A7A7A7; */
}
.copyrightDiv {
  position: absolute;
  bottom: 3rem;
  width: 100%;
  text-align: center;
  font-size: 0.75rem;
}
</style>
